<template>
  <fragment>
    <div class="col-12 d-md-block d-none">
      <h3 class="subtitle">Cheque Ressarcido</h3>
      <hr class="simple" />
    </div>
    <div class="col-12" id="divToPrint" ref="content" v-if="periodos">
      <div class="form-row form_padrao">
        <div class="form-group flutuante col-md-12">
          <input
            type="text"
            name="nomeOperador"
            id="nomeOperador"
            required
            @keyup="filterValue($event)"
          />
          <label for="nomeOperador">Pesquisar periodos - ex: 2020-04</label>
        </div>
        <!-- <button type="button" class="btn btn-azul" @click="printPage">Baixar Download</button> -->
      </div>
      <div class="row">
        <!-- <div class="col-md-4">
          <label for="combobox">Selecione um periodo</label>
          <v-select label="dtref" class="mt-2" :options="periodos" v-model="selected"></v-select>
        </div> -->
        <div
          class="col-md-6 mt-4"
          v-for="(boleto, index) in newObj"
          :key="index"
        >
          <div class="card card_content p-3">
            <div class="d-flex justify-content-between align-items-center">
              <i class="material-icons analytics">analytics</i>
              <router-link
                :to="{
                  name: 'visualizar-relatorio',
                  params: {
                    tipo: 'RelatorioChequeRessarcido',
                    periodo: boleto.dtreffat,
                  },
                }"
                class="badge badge-secondary"
                target="_blank"
                link="no-follow"
              >
                <i class="material-icons">visibility</i> Visualizar
              </router-link>
            </div>
            <div>
              <h6 class="text-uppercase font-weight-bolder">
                Extrato de Cheque Ressarcido
              </h6>
              <small class="text-muted pt-2">{{ boleto.dtreffat }}</small>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              &nbsp;
            </div>
          </div>
        </div>
        <div class="col-12" v-if="newObj.length == 0">
          <div
            class="card border-0 py-5 d-flex justify-content-center align-items-center"
          >
            <h5>Nada Encontrado. 😟</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-else>
      <loading />
    </div>
  </fragment>
</template>

<script>
import { filterByValue } from "../../helpers";
import "vue-select/dist/vue-select.css";

export default {
  name: "ChequeRessarcido",
  data() {
    return {
      relatorio: "RelatorioChequeRessarcido",
      periodoRelatorio: "AnoMesRelatorioChequeRessarcido",
      newObj: "",
      periodos: "",
      relatorioData: "",
      selected: "",
      produto: {
        nome: "Relatório de Cheque Garantido",
        id: "Relatorios",
      },
    };
  },
  watch: {
    selected(value) {
      this.getRelatorio(value.dtreffat);
    },
  },
  components: {},
  methods: {
    filterValue(value) {
      this.newObj = filterByValue(this.periodos, value.target.value);
    },
    getRelatorio(period) {
      this.$http
        .get("/api/CdlBh/" + this.relatorio + "?AnoMes=" + period)
        .then((response) => {
          this.relatorioData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPeriodos() {
      this.$http
        .get("/api/CdlBh/" + this.periodoRelatorio)
        .then((response) => {
          this.periodos = response.data.reverse();
          this.newObj = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.getPeriodos();
    this.$store.commit("UPDATE_PRODUTO", this.produto);
  },
};
</script>

<style lang="scss" scoped>
.card_content {
  min-height: 170px;
  display: flex;
  justify-content: space-between;
  &:hover {
    background: #05428e;
    color: white;
    .text-muted {
      color: white !important;
    }
  }

  small {
    line-height: 1.5rem;
  }
  .badge {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 10px;
    cursor: pointer;
    border-radius: 0px;
    i {
      font-size: 13px;
      color: white;
    }
  }
  &:hover {
    transform: scale(1.05);
  }
}
</style>
